import { ILoggedInUserData } from "./authSlice.types";
import { ISessionResponse } from "./authSlice.types";

// About Free Users
// Free users will be under user_{user_id} group.

export const getUserData = (data: ISessionResponse | null): ILoggedInUserData => {
    const userId = data?.authn.user.id;
    const selectedOrg = data?.authn.user.org_selected;

    const groups = data?.authz.user.groups || [];
    const userIsolatedGroupId =
        groups.find((group) => group.name === `drax_executive`)?.id ||
        groups.find((group) => group.name === `user_${userId}`)?.id;

    return {
        userId: data?.authn.user.id || 0,
        name: data?.authn.jwt.given_name || "",
        username: data?.authn.user.username || "",
        lastLoggedInDate: data?.authn.jwt.auth_time || 0,
        groupId: selectedOrg?.group_id || userIsolatedGroupId,
        groups: data?.authz.user.groups || [],
        selectedOrg,
    };
};
